export default __webpack_public_path__ + "static/media/gallery-wps-4.bd874c9e.jpg";